var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + alias1(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"Styles") : depth0)) != null ? lookupProperty(stack1,"container") : stack1), depth0))
    + " modal-margin\">\n    <p>"
    + alias1(((helper = (helper = lookupProperty(helpers,"bodyText") || (depth0 != null ? lookupProperty(depth0,"bodyText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"bodyText","hash":{},"data":data,"loc":{"start":{"line":2,"column":7},"end":{"line":2,"column":19}}}) : helper)))
    + "</p>\n    <div class=\"js-change-name-input\"></div>\n</div>\n";
},"useData":true});